import { Outlet } from "react-router-dom";
import SalesHeader from "./Header/SalesHeader";

const SalesPortalMain = () => {
  return (
    <div id="main-app" className="layout-veritcle-menu sidebar-collapsed">
      <div className="app-body" style={{ marginLeft: 0, width: "100%" }}>
        <SalesHeader />
        <div className="app-page pt-4 mt-5">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default SalesPortalMain;
